export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/notes-icon.svg?4dd3c9de2b63bbe42664f7d78570473a";